// extracted by mini-css-extract-plugin
export var addToCartButton = "_tn-b";
export var arrowButtonContainer = "_tn-9";
export var arrowButtonIcon = "_tn-a";
export var carouselArrowButton = "_tn-6";
export var carouselElementContainer = "_tn-1";
export var left = "_tn-7";
export var productDisplayCarouselContainer = "_tn-0";
export var productTileContainer = "_tn-2";
export var productTileImage = "_tn-4";
export var productTileImageContainer = "_tn-3";
export var productTileTitle = "_tn-5";
export var right = "_tn-8";
export var sliderOverflow = "_tn-c";